import { ResolverTag } from '@ps/web-core-store';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import StarsLink from '@swf/components/StarsLink/StarsLink';
import FacebookIcon from '@swf/core/assets/icons/facebook.svg';
import useResolver from '@swf/core/hooks/useResolver';

import styles from '../SocialShareButtons.scss';

// Official documentation for Facebook Share Button - https://developers.facebook.com/docs/plugins/share-button/ß

interface Props {
  iconStyle?: React.CSSProperties;
  href: string;
  onClick(e: React.MouseEvent): void;
}

const FacebookShareButton: React.FC<Props> = ({ href, onClick, iconStyle }) => {
  const query = {
    u: href,
    src: 'sdkpreparse'
  };
  const facebookSharer = useResolver(ResolverTag.FacebookSharer, {
    query
  });

  return (
    <div>
      <Helmet>
        <script async defer src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v12.0" />
      </Helmet>
      <StarsLink
        data-track-id="RAF_Facebook"
        className={styles.shareButton}
        target="_blank"
        rel="noopener noreferrer"
        href={facebookSharer}
        onClick={onClick}
      >
        <FacebookIcon style={iconStyle} />
      </StarsLink>
    </div>
  );
};

export default FacebookShareButton;
